
export default {
  state:{
    //当前定位
    location:{
      province:'江苏省',
      city:'南京市',
      district:'江宁区',
      longitude:118.839685,
      latitude:31.953702
    },
    isBindPhone:false,
  },
  mutations:{
    CURRENT_CITY:(state, location) => {
      state.location = location;
    },
    SET_BIND_STATUS:(state, payload) =>{
      state.isBindPhone = payload.status;
    }

  },
  actions:{

  }
}
